import { parseJsonData } from '@frontend/services/helpers';
import { initDataBuilderTable } from '@frontend/group/modules/simple-table-builder/helpers';
import { fabric } from 'fabric';
import {
  updateDynamicTemplateHeight,
} from '@frontend/utils';
import { ShowPageScopeCollector } from '@frontend/group/modules/scope-collectors/show-page-collector';
import {EVENTS, simpleTableBuilderEventBroker} from "@frontend/group/modules/simple-table-builder/event-broker";

function createHtmlImage(base64data, options, optionsData, canvas, tableObject, data, index, top_position) {
    const relatedField = parseJsonData(options['Option2'], {});

    return new Promise((resolve, reject) => {
        fabric.Image.fromURL(base64data, function (image) {
            try {
                image.set({
                    id: `html_${index}`,
                    element_id: `html_table_${index}`,
                    fieldId: options.id,
                    field_id: optionsData.id,
                    left: +options.X,
                    top: +top_position,
                    opacity: options.opacity ? options.opacity : 1,
                    fieldType: `HTML Table`,
                    tableData: tableObject.fieldOptions,
                    name: options.Name,
                    html_table_data: data.html_tables,
                    relatedField,
                    scaleX: +options.Scale || 1,
                    scaleY: +options.Scale || 1,
                    real_id: tableObject.realId,
                    visible: data['html_tables_visible']?.[index] ?? true
                });


                // avoid going outside to the right
                const rightSide = Math.round(image.left + image.width + canvas.width * 0.05)
                if (rightSide > canvas.width) {

                  const scale = canvas.width / rightSide
                  image.set({
                    scaleX: image.scaleX - (1 - scale),
                    scaleY: image.scaleY - (1 - scale),
                  })
                }

                canvas.add(image);
                canvas.renderAll();
                resolve(image); // Resolve the promise with the image
            } catch (error) {
                reject(error); // Reject in case of errors
            }
        });
    });
}

function incrementFontSize(data) {
  const incrementSize = 5;
  const incrementPx = (item) => {
    if (
      item?.styles?.rules &&
      typeof item.styles.rules["font-size"] === "string"
    ) {
      const sizeStr = item.styles.rules["font-size"];
      const value = parseInt(sizeStr, 10);
      if (!isNaN(value)) {
        item.styles.rules["font-size"] = (value + incrementSize) + "px";
        data.autoFontSizeValue = value;
      }
    }
  };

  data.headers?.forEach(incrementPx);
  data.rows?.forEach(row => {
    incrementPx(row); // apply to the row itself
    row.cells?.forEach(incrementPx); // apply to each cell in the row
  });

  return data;
}


export async function drawHtml(params, retries = 0) {
  return new Promise(async (resolve) => {
    const { canvas, data, id } = params;

    // Remove old HTML objects
    canvas.getObjects().forEach((o) => {
      if (o.id.startsWith('html')) {
        canvas.remove(o);
      }
    });

    if (data.html_tables?.length) {
      const tablePromises = []; // Array to track all table promises

      let index = 0;
      for (const o of data.html_tables) {
        let tableObject = parseJsonData(o, null);
        const options = parseJsonData(tableObject.fieldOptions, null);
        const optionsData = parseJsonData(options['Option1'], null);
        let table = initDataBuilderTable(tableObject);
        let tableOuterDimension = await table.getOuterDimension();
        table.styles.setRules({
          'width': `${tableOuterDimension.width}px`,
          'height': `${tableOuterDimension.height}px`,
        });
        let blob;

        // Maximize the font size until the point it will not increaze the original table size
        if (tableObject.autoFontSize) {
          // blob = await table.toBlob();
          let retries_resize =0;
          let conditionMet = false;
          let originalHeight = 0;
          let originalWidth = 0;
          let previousTableObject = tableObject;

          do {

            if (originalHeight == 0 && originalWidth == 0){
              originalHeight = tableOuterDimension.height;
              originalWidth =  tableOuterDimension.width;
            }
            // check if the changes in font made the table grow its original size
            if (tableOuterDimension.height > originalHeight || tableOuterDimension.width > originalWidth) {
              conditionMet = true;
              tableObject = previousTableObject;

              simpleTableBuilderEventBroker.fire(EVENTS.UPDATE_AUTO_FONT_SIZE_VALUE, {
                previewId: id,
                tableId: tableObject.id,
                autoFontSizeValue: tableObject.autoFontSizeValue
              });
            } else {
              retries_resize ++;
              // create a deep copy 
              previousTableObject = JSON.parse(JSON.stringify(tableObject));
              tableObject = incrementFontSize(tableObject);
              table = initDataBuilderTable(tableObject);
              tableOuterDimension = await table.getOuterDimension();
              // just in case so we don't get stuck in the loop
              if (retries_resize > 100 ){
                console.log("Maximize font size has reached the max number of tries ");
                conditionMet = true;
              }
            }
          } while (!conditionMet);
        
        }

        table = initDataBuilderTable(tableObject);
        blob = await table.toBlob();
        const reader = new FileReader();

        // Create a promise for each table's processing
        const tablePromise = new Promise((tableResolve, tableReject) => {
          reader.readAsDataURL(blob);
          reader.onloadend = async function () {
            const base64data = reader.result;

            let top_position = options.Y;

            // Relative field positioning
            var related_field_name = "";
            var margin = 5;
            var move_down_only = false;

            try {
              let parsedOption = parseJsonData(options['Option2'], null);

              if (parsedOption && parsedOption.field && parsedOption.field.trim() !== "") {
                related_field_name = parsedOption.field;
              }
              if (parsedOption && parsedOption.margin !== undefined) {
                margin = parsedOption.margin;
              }
              if (parsedOption && parsedOption.move_down_only !== undefined) {
                move_down_only = parsedOption.move_down_only;
              }
            } catch (e) {
              // Handle JSON parsing error
            }

            if (related_field_name) {
              var canvasObjects = canvas.getObjects();
              var related_field = null;

              canvasObjects.forEach((obj) => {
                if (obj.templateField && obj.templateField.name === related_field_name) {
                  related_field = obj;
                } else if (obj.name && obj.name === related_field_name) {
                  related_field = obj;
                }
              });

              if (related_field) {
                top_position = related_field.top + related_field.height + margin;
                if (move_down_only && top_position < options.Y) {
                  top_position = options.Y;
                }
              } else {
                // Retry logic
                await new Promise((r) => setTimeout(r, 1200));
                if (retries < 20) {
                  await drawHtml(params, retries + 1); // Use await to avoid unresolved promises
                  return tableResolve(); // Ensure the promise resolves after retry
                } else {
                  tableResolve(); // Resolve even if the retries fail after max attempts
                }
              }
            }

            createHtmlImage(
              base64data,
              options,
              optionsData,
              canvas,
              tableObject,
              data,
              index,
              top_position
            )
              .then( async (image) =>  {
                let bottom_margin = 20;
                let new_template_height = Math.round(image.top + image.height + bottom_margin);
                if (new_template_height > Math.round(params.canvas.height) ) {
                  const formData = new FormData();
                  formData.append('new_height', new_template_height);
                  await updateDynamicTemplateHeight(formData, params.id);
                  ShowPageScopeCollector.set({ NeedToRedrawEverything: true });
                }
                tableResolve(); // Resolve this table's processing
              })
              .catch((error) => {
                console.error("Error:", error);
                tableReject(error); // Reject if there's an error
              });

            index += 1;
          };
        });

        tablePromises.push(tablePromise); // Add promise to the array
      }

      // Wait for all tables to finish processing
      await Promise.all(tablePromises);
    }

    // Resolve the main promise
    resolve();
  });
}
